import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SuperComponent } from '../../../inside.super';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../../../services.module/auth.service';
import { TableCellDescriptor } from '../../../../model.module/table-cell.model';
import { SortType } from '../../../../model.module/constant/sort-types.enum';
import { KundenHandle } from '../../../../model.module/xhr/kunden-handle.model';
import { FilterFunctions } from '../../../../pipes.module/_filter.functions';
import { Permission, RoleHandler } from '../../../../model.module/constant/rights.enum';
import { MaklerApiService } from '../../../../../generated/api/makler/makler.service';
import { SteuerberaterApiService } from '../../../../../generated/api/steuerberater/steuerberater.service';

@Component({
    selector: 'kd-auswahl',
    templateUrl: './kd-auswahl.component.html',
    styleUrls: ['../../../commonless/content.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KundenAuswahlComponent extends SuperComponent implements OnInit, OnDestroy {

    kundenData: KundenHandle[] = [];

    visibleKundenData: KundenHandle[] = [];

    allKundenData: KundenHandle[];

    showActionLink = true;

    currentOffset = 0;

    kundenTargetParam = 'vsnr';

    filterCellNames: string[] = ['vsnr', 'nameVn'];

    kundenMetaData: TableCellDescriptor[] = [
        new TableCellDescriptor('VSNR', 'vsnr', null, true, SortType.NUMERICAL, '50%', true),
        new TableCellDescriptor('Name des Kunden', 'nameVn', null, true, SortType.ALPHABETICAL, '50%'),
    ];

    private sub: any;

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly maklerApiService: MaklerApiService,
        private readonly steuerberaterApiService: SteuerberaterApiService
    ) {
        super();
    }

    ngOnInit(): void {
        const userId = this.authService.getUserId();

        if (RoleHandler.isSteuerberaterRole(this.authService.getRole())) {
            this.steuerberaterApiService.getSteuerberaterKunden(userId).subscribe(result => {
                this.allKundenData = result.handles.map(handle => KundenHandle.ofVermittlerKundenHandle(handle));
                this.kundenData = this.allKundenData.filter(kh => kh.freigegeben === true);
                this.visibleKundenData = this.kundenData.slice(0);
            });
        } else {
            this.maklerApiService.getMaklerKunden(userId).subscribe(result => {
                this.allKundenData = result.handles.map(handle => KundenHandle.ofVermittlerKundenHandle(handle));
                this.sub = this.activatedRoute.params.subscribe(params => {
                    const tmp = params['subPage'];
                    const frei = 'frei' === tmp;
                    this.showActionLink = frei;
                    this.kundenData = this.allKundenData.filter(kh => kh.freigegeben === frei);
                    this.visibleKundenData = this.kundenData.slice(0);
                });
            });
        }
    }

    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    pagerAction = (page: number) => {
        this.currentOffset = page;
    };

    searchMe = (term: string) => {
        console.debug(this.kundenData);
        this.visibleKundenData = FilterFunctions.filterMatrix(this.kundenData, this.filterCellNames, term);
    };

    getActionLinkFunction(): Function {
        if (this.showActionLink) {
            return this.selectKunde;
        } else {
            return null;
        }
    }

    private selectKunde = (vsnr: string): void => {
        const kundenHandle: KundenHandle = this.kundenData.find(kd => kd.vsnr === vsnr);
        kundenHandle.$_clientOfMaklerOrStbr = true;
        kundenHandle.$_directKunde = false;
        this.authService.setActiveKunde(kundenHandle);
        this.authService.setForKunde();
        if ((this.authService.getRole() & Permission.READ_COCKPIT) === Permission.READ_COCKPIT) {
            this.router.navigate(['/kreditportal/cockpit']);
        } else {
            this.router.navigate(['/kreditportal/vertraege']);
        }
    };

}
